/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.card {
  padding: 0;
  border-radius: variables.$card-border-radius;
  height: 100%;
  border: 2px solid transparent;

  &:not(.disable-elevation) {
    -webkit-box-shadow: variables.$card-shadow;
    -moz-box-shadow: variables.$card-shadow;
    box-shadow: variables.$card-shadow;
  }

  &.highlight-border {
    border-color: variables.$color-black;
  }
  .title-subtitle {
    padding-left: variables.$card-padding;
  }
}

.title-content {
  padding: variables.$padding-medium;
}

.main-content {
  padding: 0 variables.$padding-medium variables.$padding-medium;
}

.divi-field-card-button-row {
  margin: 5px 0 variables.$margin-large 0;
  padding: 0 variables.$padding-medium 0 variables.$padding-medium;
  text-align: left;

  .no-path-button {
    margin-right: variables.$padding-large;
  }

  button.divi-toggle-button {
    color: variables.$color-black;
    font-weight: normal;
    padding: 3px 15px;
    height: 30px;
    border-radius: 30px;
    &:hover {
      background-color: variables.$color-corpuls-secondary-50;
    }
    &.MuiButton-contained {
      background-color: variables.$color-corpuls-system-green-lightest;
    }
    &.selected {
      color: variables.$color-black;
    }
    &.unknown-button {
      &.MuiButton-contained {
        background-color: variables.$color-system-blue-lightest;
      }
    }
  }
}
